import React, { Component } from "react";
import { Map, GoogleApiWrapper, Polygon } from "google-maps-react";

class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      polygonCoords: [],
    };
  }

  componentDidMount() {
    const { suburb, state, postcode } = this.props;

    const searchQuery = `${suburb}, ${state}, ${postcode}`;

    fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
        searchQuery
      )}&format=json&polygon_geojson=1`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0 && data[0].geojson) {
          const coordinates = data[0].geojson.coordinates[0];
          const polygonCoords = coordinates.map((coord) => ({
            lat: coord[1],
            lng: coord[0],
          }));
          this.setState({ polygonCoords });
        } else {
          console.error("No boundary data found for the given suburb.");
        }
      })
      .catch((error) => {
        console.error("Error fetching boundary data:", error);
      });
  }

  render() {
    const { google } = this.props;
    const { polygonCoords } = this.state;

    return (
      <Map
        google={google}
        zoom={13}
        containerStyle={{
          position: "relative",
          width: "100%",
          height: "350px",
        }}
        style={{
          width: "100%",
          height: "350px",
          border: "1px solid #054df9",
          borderRadius: "10px",
        }}
        center={polygonCoords.length > 0 ? polygonCoords[0] : null}
      >
        {polygonCoords.length > 0 && (
          <Polygon
            paths={polygonCoords}
            strokeColor="#054df9"
            strokeOpacity={1}
            strokeWeight={3}
            fillColor="#054df9"
            fillOpacity={0.2}
          />
        )}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyC1AeWUWRS0KwEzi2Yap83nRHEEGkR7MBc",
})(MapContainer);
